// Home.jsx
import { Hero } from "../components/Hero";
import { Services } from "../components/Services";
import { Products } from "../components/Products";
import { Contact } from "../components/Contact";
import AboutPreview from "./AboutPreview";

export default function Home() {
  return (
    <>
      <Hero />
      <AboutPreview />
      <Services />
      <Products />
      <Contact />
    </>
  );
}
